(function ($) {
    var suggestionEngines = {};
    var templates = {};
    $(function () {
        $('.js-typeahead-control').each(function () {
            var remote_url = $(this).data('remoteUrl');
            var limit = $(this).data('suggestionLimit');
            var limit_param_name = $(this).data('suggestionLimitParamName');
            remote_url += (remote_url.indexOf('?') == -1 ? '?' : (remote_url.charAt(remote_url.length - 1) != '&' ? '&' : '')) + $(this).attr('name') + '=%QUERY' + ((limit != '' && limit > 0) ? '&' + limit_param_name + '=' + limit : '');
            if (!suggestionEngines.hasOwnProperty(remote_url)) {
                suggestionEngines[remote_url] = new Bloodhound({
                    // identify: function (obj) { return obj.id; },
                    datumTokenizer: Bloodhound.tokenizers.whitespace,
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: remote_url,
                        wildcard: '%QUERY'
                    }
                    //use transform function to pull total search count from response before bloodhound generates tokens n stuff.. we can also use the transform function to pull other data from the response (like data for product list and side menus.. whatever.. like beta.nemlig.com)
                });
            }

            var empty_tmpl = $(this).data('emptyTemplate');
            if (!templates.hasOwnProperty(empty_tmpl)) templates[empty_tmpl] = Handlebars.compile($('#' + empty_tmpl).html());
            var header_tmpl = $(this).data('headerTemplate');
            if (!templates.hasOwnProperty(header_tmpl)) templates[header_tmpl] = Handlebars.compile($('#' + header_tmpl).html());
            var suggestion_tmpl = $(this).data('suggestionTemplate');
            if (!templates.hasOwnProperty(suggestion_tmpl)) templates[suggestion_tmpl] = Handlebars.compile($('#' + suggestion_tmpl).html());
            var footer_tmpl = $(this).data('footerTemplate');
            if (!templates.hasOwnProperty(footer_tmpl)) templates[footer_tmpl] = Handlebars.compile($('#' + footer_tmpl).html());

            var navigateOnSelect = $(this).data('navigateOnSelect');
            var indicatorSelector = $(this).data('loadIndicatorSelector');

            $(this).typeahead({
                hint: $(this).data('hint') == "True",
                highlight: $(this).data('highlight') == "True",
                minLength: parseInt($(this).data('minlength'))
            },
            {
                limit: limit,
                display: $(this).data('displayProperty'),
                source: suggestionEngines[remote_url],
                templates: {
                    header: templates[header_tmpl],
                    footer: templates[footer_tmpl],
                    empty: templates[empty_tmpl],
                    suggestion: templates[suggestion_tmpl]
                }
            }).on('typeahead:select', function (e, so) {
                if (navigateOnSelect && so.url) {
                    window.location.href = so.url;
                }
            }).on('typeahead:asyncrequest', function () {
                if (indicatorSelector != "" && $(indicatorSelector).length) {
                    $(indicatorSelector).addClass('loading');
                } else {
                    $(this).closest(".search-input-wrapper").addClass('loading');
                }
            }).on('typeahead:asynccancel typeahead:asyncreceive', function () {
                if (indicatorSelector != "" && $(indicatorSelector).length) {
                    $(indicatorSelector).removeClass('loading');
                } else {
                    $(this).closest(".search-input-wrapper").removeClass('loading');
                }
            });
        });
    });
})(jQuery);